import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dashboard-chart-error-template',
  templateUrl: './dashboard-chart-error-template.component.html',
  styleUrls: ['./dashboard-chart-error-template.component.scss']
})
export class DashboardChartErrorTemplateComponent {

  @Input() error?: string | null = null
  @Input() height = '200px'

}
